"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));
var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));
var _AttachMoney = _interopRequireDefault(require("@material-ui/icons/AttachMoney"));
var _SupervisorAccount = _interopRequireDefault(require("@material-ui/icons/SupervisorAccount"));
var _Rowing = _interopRequireDefault(require("@material-ui/icons/Rowing"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _currency = require("../../utils/currency");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      borderRadius: "14px",
      position: "relative",
      backdropFilter: "blur(3px)",
      background: "linear-gradient(to right bottom, rgba(255,255,255,0.9), rgba(255,255,255,0.7))"
    },
    searchButton: _defineProperty({
      position: "absolute",
      borderRadius: "14px",
      right: theme.spacing(3),
      height: theme.spacing(7),
      bottom: -theme.spacing(4)
    }, theme.breakpoints.up("sm"), {
      right: theme.spacing(4)
    }),
    item: {
      position: "relative"
    },
    whiteBg: {
      "& .MuiInputBase-root, & .MuiSelect-root": {
        background: "linear-gradient(to bottom, rgba(255,255,255,0.4), rgba(255,255,255,1) 7%)"
      },
      "& .MuiOutlinedInput-inputAdornedStart": {
        paddingLeft: theme.spacing(2)
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.action.active
      },
      "& .MuiFormLabel-root:not(.Mui-focused)": {
        color: theme.palette.text.primary
      },
      borderRadius: theme.shape.borderRadius
    }
  };
});
function Searchbar(_ref) {
  var locations = _ref.locations,
    boatTypes = _ref.boatTypes,
    onSearch = _ref.onSearch,
    isMobile = _ref.isMobile,
    location = _ref.location,
    setLocation = _ref.setLocation,
    selectedBoatTypes = _ref.selectedBoatTypes,
    setSelectedBoatTypes = _ref.setSelectedBoatTypes,
    capacity = _ref.capacity,
    setCapacity = _ref.setCapacity,
    maxPrice = _ref.maxPrice,
    setMaxPrice = _ref.setMaxPrice,
    searchBoxItems = _ref.searchBoxItems,
    boatLowestPrice = _ref.boatLowestPrice,
    currency = _ref.currency;
  var _useStyles = useStyles(),
    root = _useStyles.root,
    searchButton = _useStyles.searchButton,
    item = _useStyles.item,
    whiteBg = _useStyles.whiteBg;
  var lgGrid = (0, _react.useMemo)(function () {
    if ((searchBoxItems === null || searchBoxItems === void 0 ? void 0 : searchBoxItems.length) === 1) {
      return 12;
    }
    if ((searchBoxItems === null || searchBoxItems === void 0 ? void 0 : searchBoxItems.length) === 2) {
      return 7;
    }
    if ((searchBoxItems === null || searchBoxItems === void 0 ? void 0 : searchBoxItems.length) === 3) {
      return searchBoxItems.includes("location") ? 5 : 6;
    }
    return 3;
  }, [searchBoxItems]);
  var mdGrid = (0, _react.useMemo)(function () {
    if ((searchBoxItems === null || searchBoxItems === void 0 ? void 0 : searchBoxItems.length) === 1) {
      return 12;
    }
    if ((searchBoxItems === null || searchBoxItems === void 0 ? void 0 : searchBoxItems.length) === 2) {
      return ["capacity", "maxPrice"].some(function (v) {
        return searchBoxItems.includes(v);
      }) ? 7 : 5;
    }
    if ((searchBoxItems === null || searchBoxItems === void 0 ? void 0 : searchBoxItems.length) === 3) {
      return searchBoxItems.includes("boatType") ? 4 : 6;
    }
    return 3;
  }, [searchBoxItems]);
  var smGrid = (0, _react.useMemo)(function () {
    if ((searchBoxItems === null || searchBoxItems === void 0 ? void 0 : searchBoxItems.length) === 1) {
      return 12;
    }
    if ((searchBoxItems === null || searchBoxItems === void 0 ? void 0 : searchBoxItems.length) === 2) {
      return ["boatType", "location"].some(function (v) {
        return searchBoxItems.includes(v);
      }) ? 5 : 6;
    }
    return 3;
  }, [searchBoxItems]);
  var renderSwitch = function renderSwitch(type) {
    switch (type) {
      case "location":
        return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
          item: true,
          sm: isMobile ? 12 : mdGrid,
          xs: 12,
          className: item
        }, /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
          className: whiteBg,
          options: locations || [],
          getOptionLabel: function getOptionLabel(option) {
            return option.name || "";
          },
          onChange: function onChange(_, v) {
            setLocation(v || {});
          },
          value: location,
          fullWidth: true,
          renderInput: function renderInput(params) {
            return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({}, params, {
              label: "Location",
              helperText: "Where abouts?",
              variant: "outlined",
              InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
                startAdornment: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
                  position: "start"
                }, /*#__PURE__*/_react["default"].createElement(_LocationOn["default"], {
                  position: "start"
                })), params.InputProps.startAdornment)
              })
            }));
          }
        }));
      case "boatType":
        return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
          item: true,
          sm: lgGrid,
          xs: 12,
          className: item
        }, /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
          multiple: true,
          className: whiteBg,
          options: boatTypes || [],
          getOptionLabel: function getOptionLabel(option) {
            return option.name || "";
          },
          onChange: function onChange(_, v) {
            setSelectedBoatTypes(v);
          },
          value: selectedBoatTypes,
          fullWidth: true,
          renderInput: function renderInput(params) {
            var _extends2;
            return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({}, params, (_extends2 = {
              variant: "standard",
              label: "Boat Types",
              helperText: "What types of boat? (you can select multiple)"
            }, _defineProperty(_extends2, "variant", "outlined"), _defineProperty(_extends2, "InputProps", _objectSpread(_objectSpread({}, params.InputProps), {}, {
              startAdornment: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
                position: "start"
              }, /*#__PURE__*/_react["default"].createElement(_Rowing["default"], {
                position: "start"
              })), params.InputProps.startAdornment)
            })), _extends2)));
          }
        }));
      case "maxPrice":
        return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
          item: true,
          sm: smGrid,
          xs: 12,
          className: item
        }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          type: "number",
          className: whiteBg,
          onChange: function onChange(e) {
            return setMaxPrice(e.target.value);
          },
          value: maxPrice,
          fullWidth: true,
          label: "Max Price",
          placeholder: "Rate per hour",
          variant: "outlined",
          helperText: boatLowestPrice ? "From ".concat((0, _currency.toCurrency)(boatLowestPrice, currency), " per hour") : "per hour",
          InputProps: {
            startAdornment: /*#__PURE__*/_react["default"].createElement(_AttachMoney["default"], {
              position: "start"
            })
          }
        }));
      case "capacity":
        return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
          item: true,
          sm: smGrid,
          xs: 12,
          className: item
        }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          placeholder: "eg 10 or 10-20 for a range",
          className: whiteBg,
          onChange: function onChange(e) {
            return setCapacity(e.target.value);
          },
          value: capacity,
          fullWidth: true,
          label: "Capacity",
          variant: "outlined",
          helperText: "How many people?",
          InputProps: {
            startAdornment: /*#__PURE__*/_react["default"].createElement(_SupervisorAccount["default"], {
              position: "start"
            })
          }
        }));
      default:
        break;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_core.Paper, {
    elevation: 1,
    className: root
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    p: 4
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, (searchBoxItems || []).map(function (item, idx) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: idx
    }, renderSwitch(item));
  })), onSearch && /*#__PURE__*/_react["default"].createElement(_core.Button, {
    className: searchButton,
    variant: "contained",
    color: "primary",
    size: "large",
    endIcon: /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], null),
    onClick: function onClick() {
      return onSearch && onSearch(location, selectedBoatTypes, capacity, maxPrice);
    }
  }, "Search Boats")));
}
Searchbar.propTypes = {
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  boatTypes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  onSearch: _propTypes["default"].func,
  isMobile: _propTypes["default"].bool,
  location: _propTypes["default"].object,
  selectedBoatTypes: _propTypes["default"].arrayOf(_propTypes["default"].object),
  maxPrice: _propTypes["default"].string,
  capacity: _propTypes["default"].string,
  setLocation: _propTypes["default"].func,
  setSelectedBoatTypes: _propTypes["default"].func,
  setMaxPrice: _propTypes["default"].func,
  setCapacity: _propTypes["default"].func
};
var _default = exports["default"] = Searchbar;